import ArrowUpDownBold from './ArrowUpDownBold';

export default ArrowUpDownBold;
